import React from 'react';
import { Container, Typography, Box } from '@material-ui/core';
import ButtonDefault from '../shared/button/button';
import { HeroLogic, useStyles } from './hero.module';

const Hero = () => {
  const { translator } = HeroLogic();
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      <Box className={classes.contentBlock}>
        <Box className={classes.badge}>
          <Typography component="span" className={classes.badgeText}>
            {translator('hero.badge')}
          </Typography>
        </Box>

        <Typography component="h1" className={classes.title}>
          {translator('hero.title')}
        </Typography>

        <Box className={classes.subtitleRow}>
          <Box className={classes.stateCard}>
            <Typography component="span" className={classes.stateLabel}>
              {translator('hero.stateCurrentLabel')}
            </Typography>
            <Typography component="p" className={classes.stateTitle}>
              {translator('hero.stateCurrentTitle')}
            </Typography>
            <Typography component="p" className={classes.stateText}>
              {translator('hero.stateCurrentText')}
            </Typography>
          </Box>

          <Typography component="p" className={classes.subtitle}>
            {translator('hero.subtitle')}
          </Typography>

          <Box className={classes.stateCard}>
            <Typography component="span" className={classes.stateLabelTarget}>
              {translator('hero.stateTargetLabel')}
            </Typography>
            <Typography component="p" className={classes.stateTitle}>
              {translator('hero.stateTargetTitle')}
            </Typography>
            <Typography component="p" className={classes.stateText}>
              {translator('hero.stateTargetText')}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.buttonsRow}>
          <ButtonDefault type="heroOutline" text={translator('hero.button1')} />
          <ButtonDefault type="heroOutline" text={translator('hero.button2')} />
        </Box>
      </Box>

      <Box className={classes.ambitionSection}>
        <Typography component="span" className={classes.ambitionLabel}>
          {translator('hero.ambitionLabel')}
        </Typography>
        <Typography component="p" className={classes.ambitionQuote}>
          "{translator('hero.ambitionQuote')}"
        </Typography>
      </Box>
    </Container>
  );
};

export default Hero;
